import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDates } from "../../../../hooks/useDates";
import GenericPromises from "../../../../api/GenericPromises";
import { useCallback, useEffect, useRef, useState } from "react";
import { GridColDef, GridRenderCellParams, GridRowSelectionModel, GridRowsProp, GridTreeNodeWithRender, GridValueGetterParams } from "@mui/x-data-grid";
import { Menuitem } from "../../../../interfaces/Security/menu";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import { usePermissions } from "../../../../hooks/usePermissions";
import { ReceiptDetail, ReceiptStatus } from "../../../../interfaces/Sales/Receipts/receipts";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../components/Header";
import DataTable from "../../../../components/Tables/GridTableMaterialUI/DataTable";
import { ButtonStyled, PrimaryButton } from "../../../../theme/buttons";
import MoneyIcon from '@mui/icons-material/Money';
import { DialogEntity } from "../../../../components/Dialogs/DialogEntity";
import { DialogReceipt } from "../DialogReceipt";
import { useFormatNumber } from "../../../../hooks/useFormatNumber";
import { ViewReceiptDetails } from "./view";
import { Box, Button, Tooltip, tooltipClasses } from "@mui/material";
import { useParamsFilter } from "../../../../hooks/useParamsFilter";
import EmailIcon from '@mui/icons-material/Email';
import { DialogSendEmailsTable } from "../helpers/dialogSendEmailsTable";
import { CompanyLocation } from "../../../../interfaces/Security/companies";
import { useReceiptDetailsColumns } from "./Table/columns";
import DataTableSticky from "../../../../components/Tables/GridTableMaterialUI/DataTableSticky";
import { FilterTable, FilterTableRef } from "../../../../components/Filter";
import { usePreferenceTypesStore } from "../../../../store/Preferences/PreferencesStore";
import { useGridPreferences } from "../../../../hooks/useGridPreferences";
import { PreferenceType } from "../../../../interfaces/Commons/Preferences/preferences";

export const TableReceiptsDetails = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const { GenericGetResource, GenericGetResourceGeneric } = GenericPromises();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [unauthorized, setUnauthorized] = useState(true);
  const [dialogPayment, setDialogPayment] = useState(false);
  const [hiddenHeaderCheckBox, setHiddenHeaderCheckBox] = useState(true);
  const [openDialogView, setOpenDialogView] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [clickedButtonGoBack, setClickedButtonGoBack] = useState(false);
  const [dataEmails, setDataEmails] = useState<any>([]);
  const [receiptDetailPayload, setReceiptDetailPayload] = useState<ReceiptDetail>({});
  const [selectedRows, setSelectedRows] = useState<GridRowsProp>([]);
  const [receiptsDetailsData, setReceiptsDetailsData] = useState<GridRowsProp>([]);
  const [receiptsDetailsDataAll, setReceiptsDetailsDataAll] = useState<GridRowsProp>([]);
  const [myCustomerId, setMyCustomerId] = useState(0);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [resourceReceipts, setResourceReceipts] = useState<Menuitem>();
  const [resourceSendEmail, setResourceSendEmail] = useState<Menuitem>();
  const [messageSnack, setMessageSnack] = useState("");
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [myPreferences, setMyPreferences] = useState({});
  const { GetResourceByUrl } = usePermissions();
  const [myRfcCustomer, setMyRfcCustomer] = useState("");
  const [isSelectedUuid, setIsSelectedUuid] = useState(true);
  const [isPaymentModePUE, setIsPaymentModePUE] = useState(true)
  const [companyLocation, setCompanyLocation] = useState<CompanyLocation>()
  const { columnsReceiptDetails } = useReceiptDetailsColumns();
  const [columns, setColumns] = useState<GridColDef<ReceiptDetail>[]>([]);
  const initFilter = '/receiptsdetails?filter='
  const defaultFilter = [{ idFilter: 1, column: "status_name", operator: "!=", value: "Cobrado" }]
  const [isLoadingData, setIsLoadingData] = useState(true);
  const {
    LoadColumnsOrder,
    LoadColumnsVisible,
    LoadColumnsSort,
    VerifyPreferenceOrderByResourceRoute,
    VerifyPreferenceVisualByResourceRoute,
    VerifyPreferenceSortByResourceRoute,
  } = useGridPreferences();
  const { preferenceTypes } = usePreferenceTypesStore.getState();
  const [mySortPreference, setMySortPreference] = useState([]);
  const [isLoadedMyLocalPreferences, setIsLoadedMyLocalPreferences] = useState(false);
  const refTableFilter = useRef<FilterTableRef>(null);
  const { setFormatNumberFromTable, setFormatNumber } = useFormatNumber();
  const { ConvertParamsToBase64 } = useParamsFilter();
  const { TimeConverter } = useDates();

  const myCustomColumns: GridColDef<any>[] = [
    {
      field: 'sales_invoice_name', headerName: t("salesinvoices.fields.sales_invoice_name"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        return (
          <Button onClick={() => {
            let stringConverted = ConvertParamsToBase64(`sales_invoice_id=${params.row.sales_invoice_id}`);
            window.open(`/salesinvoices/view?${stringConverted}`, '_blank');
          }}>
            {params.row.sales_invoice_name}
          </Button>
        );
      }
    },
    {
      field: 'project_name', headerName: t("projects.fields.project_name"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        return (
          <Button
            disabled={(params.row.project_name) ? false : true}
            onClick={() => {
              if (params.row.project_id) {
                let stringConverted = ConvertParamsToBase64(`project_id=${params.row.project_id}`);
                window.open(`/projects/view?${stringConverted}`, '_blank');
              }
            }}
          >
            {params.row.project_name}
          </Button>
        );
      }
    },
    { field: 'customer_business_name', headerName: t("projects.fields.customer"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'related_currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'total_company_currency_amount', headerName: t("companies.configuration.fields.total_company_currency_amount"), headerClassName: 'header-grid-table', flex: 1,
      valueGetter(params) {
        return setFormatNumberFromTable(params.value ?? 0);
      },
    },
    {
      field: 'amount_outstanding', headerName: t("receiptsdetails.fields.amount_outstanding"), headerClassName: 'header-grid-table', flex: 1,
      valueGetter(params) {
        return setFormatNumberFromTable(params.value ?? 0);
      },
    },
    { field: 'user_mail_send', headerName: t("payments.fields.user_mail_send"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'date_mail_send', headerName: t("payments.fields.date_mail_send"), headerClassName: 'header-grid-table', flex: 1, type: 'date',
      valueGetter(params) {
        return (params.value) ? TimeConverter(params.value) : undefined;
      },
    },
  ];

  const methodUsed = useCallback(() => {
    switch (location.state.method) {
      case "add":
        {
          showSnackBar(t("generic.snackbar.add"), "success");
          break;
        }
      case "delete":
        {
          showSnackBar(t("generic.snackbar.delete"), "success");
          break;
        }
    }

  }, [location.state, t]);

  const loadTablePreferences = async () => {
    // get preferencetypes in Store
    let hasPreferenceOrder: boolean = false;
    // if exists preferencetypes
    if (preferenceTypes.length) {
      // if exists order preferences
      let myPreferencesColumnsOrder = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsOrder");
      if (myPreferencesColumnsOrder) {
        try {
          const preference = await VerifyPreferenceOrderByResourceRoute(
            "/receiptsdetails",
            myPreferencesColumnsOrder.preference_type_id ?? 0
          );
          if (preference) {
            let myColumns = await LoadColumnsOrder("/receiptsdetails", myCustomColumns, preference?.preference_value, true)
            const filteredColumns = myColumns.filter((column) => {
              const noColumns = [
                "exchange_rate",
                "total_tax_amount",
                "total_retention_amount",
                "subtotal_amount",
                "total_amount",
                "related_total_tax_amount",
                "related_total_retention_amount",
                "previous_amount",
                "payment_amount"
              ];
              return !noColumns.includes(column.field);
            });
            setColumns(filteredColumns);
            hasPreferenceOrder = true;
          }
        } catch (error) {
          showSnackBar(`Error fetching column order preferences:${error}`, "error");
        }
      }

      let myPreferencesColumnsVisual = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsVisibility");
      // if exists visual preferences
      if (myPreferencesColumnsVisual) {
        try {
          const preference = await VerifyPreferenceVisualByResourceRoute(
            "/receiptsdetails",
            myPreferencesColumnsVisual.preference_type_id ?? 0
          );
          if (preference) {
            let myLocalPreferences = await LoadColumnsVisible("/receiptsdetails", preference);
            setMyPreferences(myLocalPreferences);
          }
        } catch (error) {
          console.error("Error fetching column visual preferences:", error);
        }
      }

      let myPreferencesColumnsSort = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsSorting");
      // if exists sort preferences
      if (myPreferencesColumnsSort) {
        try {
          const preference = await VerifyPreferenceSortByResourceRoute(
            "/receiptsdetails",
            myPreferencesColumnsSort.preference_type_id ?? 0
          );
          if (preference) {
            let myLocalPreferences = await LoadColumnsSort("/receiptsdetails", preference);
            setMySortPreference(myLocalPreferences);
          }
        } catch (error) {
          console.error("Error fetching column sort preferences:", error);
        }
      }

    }
    if (!hasPreferenceOrder) {
      setColumns(columnsReceiptDetails);
    }
    setIsLoadedMyLocalPreferences(true);
  }

  const onSendEmail = async () => {
    let myDataEmails: any = [];
    const filteredRows = selectedRows.filter(element => element.receipt_id && element.uuid)
      .reduce((arrayIndex, currentRow) => {
        if (!arrayIndex.some((item: any) => item.receipt_id === currentRow.receipt_id)) {
          arrayIndex.push(currentRow)
        }
        return arrayIndex;
      }, []);
    let myCustomer: any;
    if (filteredRows.length > 0) {
      myCustomer = await GenericGetResource(`/customers/${filteredRows[0].customer_id}`);
    }
    filteredRows.forEach((element: any) => {
      let data = {
        data: {
          ...element,
          customer_email: (myCustomer?.data.customer_email) ?? '',
          customer_language: (myCustomer?.data.customer_language) ?? '',
        },
        status: (myCustomer?.data.customer_email) ? "Waiting" : "Error",
        status_description: (myCustomer?.data.customer_email) ? "generic.send_email.waiting" : "generic.send_email.no_email"
      }
      myDataEmails.push(data);
    });
    setDataEmails((prev: any) => myDataEmails);
  }

  const onRowSelection = (rowsIds: GridRowSelectionModel) => {
    if (rowsIds.length === 1) {
      if (hiddenHeaderCheckBox) {
        setReceiptsDetailsDataAll(receiptsDetailsData);
      }
      let myRow = receiptsDetailsData.find(item => item.receipt_detail_id === rowsIds[0])
      setMyRfcCustomer(myRow?.customer_rfc ?? "");
      setMyCustomerId(myRow?.customer_id ?? 0);
      setIsSelectedUuid(myRow?.uuid_related ? true : false);
      setIsPaymentModePUE(myRow?.payment_mode_code === "PUE" ? true : false);
      let myCompanyLocation: CompanyLocation = {
        company_location_id: myRow?.company_location_id,
        street: myRow?.company_street,
        city_name: myRow?.company_city_name,
        city_code: myRow?.company_city_code,
        state_name: myRow?.company_state_name,
        state_abbr: myRow?.company_state_abbr,
        country_name: myRow?.company_country_name,
        country_code: myRow?.company_country_code,
        postal_code: myRow?.company_postal_code,
        company_rfc: myRow?.company_rfc,
        tax_regime_code: myRow?.company_tax_regime_code,
        tax_regime_description: myRow?.company_tax_regime_description,
        business_name: myRow?.company_business_name,
        rpt_image: myRow?.company_rpt_image,
      }
      setCompanyLocation(myCompanyLocation);
      setReceiptsDetailsData((prev) => prev.filter((item) => item.customer_id === myRow?.customer_id &&
        item.customer_business_name === myRow?.customer_business_name && item.company_business_name === myRow?.company_business_name));
      setDataEmails(receiptsDetailsData.filter(receipt => rowsIds.includes(receipt.receip_detail_id)));
      setHiddenHeaderCheckBox(false);
    }
    else if (rowsIds.length === 0) {
      setReceiptsDetailsData(receiptsDetailsDataAll);
      setDataEmails([]);
      setHiddenHeaderCheckBox(true);
    }
    setSelectedRows((prev) => {
      return receiptsDetailsData.filter(item => rowsIds.includes(item.receipt_detail_id));
    });
  }

  useEffect(() => {
    setDataLoaded(false);
    if (refTableFilter && refTableFilter.current && refTableFilter.current?.applyFilter) {
      refTableFilter.current?.applyFilter();
    }
    let myPermissions = [
      GetResourceByUrl(`/receipts`),
      GetResourceByUrl(`/receiptsdetails`),
      GetResourceByUrl(`/receiptsdetails/sendemail`),
    ]
    Promise.all(myPermissions)
      .then((responses) => {
        setResourceReceipts((prev) => responses[0]);
        setResourceScreen((prev) => responses[1]);
        setResourceSendEmail((prev) => responses[2]);
      })
      .catch((error) => {
        setMessageSnack(error.message);
        showSnackBar(error.message, "error");
        setUnauthorized(false);
      });
  }, [clickedButtonGoBack])

  const haveNoFilter = async () => {
    if (refTableFilter && refTableFilter.current && refTableFilter.current?.getDataByRoute) {
      const myData = await refTableFilter.current.getDataByRoute("/receiptsdetails");
      setReceiptsDetailsData(myData);
    }
  }

  useEffect(() => {
    GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
      document.title = `${response.data.data[0].comercial_name} - ${t("receiptsdetails.title")}`;
    })
    refTableFilter.current?.applyFilter();
    if (location.state !== null && location.state.method) methodUsed();
    let myPermissions = [
      GetResourceByUrl(`/receipts`),
      GetResourceByUrl(`/receiptsdetails`),
      GetResourceByUrl(`/receiptsdetails/sendemail`),
    ]
    Promise.all(myPermissions)
      .then((responses) => {
        setResourceReceipts((prev) => responses[0]);
        setResourceScreen((prev) => responses[1]);
        setResourceSendEmail((prev) => responses[2]);
        loadTablePreferences();
      })
      .catch((error) => {
        setMessageSnack(error.message);
        showSnackBar(error.message, "error");
        setUnauthorized(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { }, [receiptsDetailsData]);

  useEffect(() => { }, [hiddenHeaderCheckBox]);

  useEffect(() => {
    if (isLoadedMyLocalPreferences && receiptsDetailsData) {
      setDataLoaded(true);
    }
  }, [receiptsDetailsData, isLoadedMyLocalPreferences]);

  return (
    <>
      {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}
      <div className='screen-container'>
        <Header
          size="sm"
          title={t("receiptsdetails.title")}
          child={
            <div className="d-flex flex-row-reverse">
              <PrimaryButton size="small" variant='outlined' className="m-1" sx={{ color: 'primary.main' }} disabled={(selectedRows?.length === 0) || !resourceReceipts?.create} onClick={() => setDialogPayment(true)}>
                {t("receiptsdetails.buttons.apply-receipt")}<MoneyIcon sx={{ marginLeft: 1 }} />
              </PrimaryButton>
              {resourceSendEmail?.create === true &&
                <ButtonStyled size="small" variant='outlined' className="m-1" sx={{ color: 'primary.main' }} disabled={selectedRows.length === 0} onClick={async () => { await onSendEmail(); setOpenEmail(true); }}>
                  {t("generic.buttons.send_email")}<EmailIcon sx={{ marginLeft: 1 }} />
                </ButtonStyled>
              }
              <FilterTable
                setIsLoadingDataTable={setIsLoadingData}
                setDataTable={setReceiptsDetailsData}
                showSnackBar={showSnackBar}
                columnsTable={columnsReceiptDetails}
                initFilter={initFilter}
                resourceRoute="/receiptsdetails"
                defaultFilter={defaultFilter}
                onFilterEmpty={haveNoFilter}
                ref={refTableFilter}
              />
            </div>
          }
        />
        {unauthorized && !dataLoaded && <Spinner />}
        {dataLoaded && resourceScreen?.read && <>
          <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
            <DataTableSticky
              columns={columns}
              setColumns={setColumns}
              data={receiptsDetailsData}
              entityId={"receipt_detail_id"}
              entity={`ReceiptsDetails`}
              preferences={myPreferences}
              namePreferences={"/receiptsdetails"}
              nameOrderColumns={"/receiptsdetails"}
              selectRows
              hiddenHeaderCheckBox={hiddenHeaderCheckBox}
              onRowSelectionModelChange={(rowsIds) => onRowSelection(rowsIds)}
              isChildren={true}
              setOpenDialog={setOpenDialogView}
              setDataRow={setReceiptDetailPayload}
              conditionalOpenRow={`receipt_id`}
              countColumns={["total_company_currency_amount"]}
              isLoading={isLoadingData}
              sortPreference={mySortPreference}
            />
          </Box>
          <DialogEntity
            open={openDialogView}
            setOpen={setOpenDialogView}
            title={
              <></>
            }
            fullWidth
            content={
              <ViewReceiptDetails
                receiptDetailPayload={receiptDetailPayload}
                permissionsReceiptsDetails={resourceScreen}
                permissionsReceipts={resourceReceipts}
                setOpenDialogView={setOpenDialogView}
                setClickedButtonGoBack={setClickedButtonGoBack}
              /* UpdateRow={handleUpdateRow} */
              />
            }
          />
          <DialogEntity
            open={dialogPayment}
            title={<></>}
            fullWidth={true}
            content={
              <DialogReceipt
                rows={receiptsDetailsData}
                isSelectedUuid={isSelectedUuid}
                myRfcCustomer={myRfcCustomer}
                customer_id={myCustomerId}
                selectedRows={selectedRows}
                setDialogPayment={setDialogPayment}
                setClickedButtonGoBack={setClickedButtonGoBack}
                myCompanyLocation={companyLocation}
                isPaymentModePUE={isPaymentModePUE}
              />
            }
          />
          <DialogSendEmailsTable
            open={openEmail}
            setOpen={setOpenEmail}
            dataReceiptsDetailsSelected={dataEmails}
            showSnackBar={showSnackBar}
          />
          <SnackbarComponent />
        </>
        }
      </div>
    </>
  )
}
